const data = {
  namespaced: true,
  state: {
    Stack: [],
    Pointer: 0, // 历史记录的指针
    is_change: false, // 表示是否修改，如果修改了，就要提示保存
    uploading: false,
    hasUnsavedChange: false
  },
  mutations: {},
  actions: {},
  getters: {
    undo_state(state) {
      if (state.Pointer <= 0) {
        return false
      } else {
        return true
      }
    },
    redo_state(state) {
      if (state.Pointer >= state.Stack.length - 1) {
        return false
      } else {
        return true
      }
    }
  }
}

export default data
